import React, { useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { patientInfo } from '../data/content';
import { practice } from '../data/site';
import { SectionLabel } from './ui/SectionLabel';
import { Reveal } from './ui/Reveal';
export function PatientInfo() {
  const [open, setOpen] = useState<number | null>(0);
  const reduce = useReducedMotion();
  return <section id="patient-info" className="scroll-mt-24 bg-paper-off py-24 lg:py-40" data-id="element-374" data-mp="ejvw5rkwzogt">
      <div className="mx-auto grid max-w-shell gap-14 px-5 sm:px-8 lg:grid-cols-[400px_1fr] lg:gap-24 lg:px-12" data-id="element-375" data-mp="jip65a0zsxc8">
        <Reveal data-id="element-376" data-mp="of5vg7jxhhqw">
          <SectionLabel data-id="element-377" data-mp="offjhplexety">Before your visit</SectionLabel>
          <h2 className="font-display mt-6 text-[clamp(2rem,3.8vw,3rem)] leading-[1.06] text-ink" data-id="element-378" data-mp="t7qk6unz94nk">
            Clear information for
            <br data-id="element-379" data-mp="3rx78qw85zkog" />
            your next visit.
          </h2>
          <p className="mt-6 max-w-[40ch] text-[16px] leading-[1.85] text-ink/65" data-id="element-380" data-mp="qeao18o41o5">
            If you need something that is not listed here, call us at{' '}
            <a href={practice.phoneHref} className="font-medium text-ink underline underline-offset-4" data-id="element-381" data-mp="ns70k7eer5fp">
              {practice.phone}
            </a>{' '}
            and we will gladly help.
          </p>
        </Reveal>

        <Reveal delay={0.08} data-id="element-382" data-mp="9y663puho4l5">
          <dl className="border-t border-ink/15" data-id="element-383" data-mp="9x4xds0y3u6l">
            {patientInfo.map((item, index) => {
            const isOpen = open === index;
            return <div key={item.q} className="border-b border-ink/15" data-id="element-384" data-mp="3w4kz9bnoktrn" data-mpi={index}>
                  <dt data-id="element-385" data-mp="3r6b4311yht61">
                    <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`info-panel-${index}`} id={`info-button-${index}`} className="flex min-h-[68px] w-full items-center justify-between gap-6 py-5 text-left" data-id="element-386" data-mp="3r7un2zezyibi">
                      <span className="text-[17px] font-medium leading-snug text-ink" data-id="element-387" data-mp="3evimv5t3lo9y">
                        {item.q}
                      </span>
                      <span className="shrink-0" data-id="element-388" data-mp="35wovbtumjo39">
                        {isOpen ? <MinusIcon aria-hidden="true" className="h-5 w-5 text-ink" strokeWidth={1.5} data-id="element-389" data-mp="39xh5cpbblx0l" /> : <PlusIcon aria-hidden="true" className="h-5 w-5 text-accent" strokeWidth={1.5} data-id="element-390" data-mp="6gi8tfqp0g58" />}
                      </span>
                    </button>
                  </dt>
                  {/* The answer always stays in the DOM for search engines and for MANGO. */}
                  <motion.dd id={`info-panel-${index}`} aria-labelledby={`info-button-${index}`} initial={false} animate={{
                height: isOpen ? 'auto' : 0,
                opacity: isOpen ? 1 : 0
              }} transition={{
                duration: reduce ? 0 : 0.3,
                ease: [0.2, 0.8, 0.2, 1]
              }} className="overflow-hidden" data-id="element-391" data-mp="2i4huahdyesxi">
                    <p className="max-w-[70ch] pb-7 pr-6 text-[16px] leading-[1.85] text-ink/70" data-id="element-392" data-mp="1m0r7ciz45ytc">
                      {item.a}
                    </p>
                  </motion.dd>
                </div>;
          })}
          </dl>
        </Reveal>
      </div>
    </section>;
}